import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, Flowbite, Alert } from 'flowbite-react';
import { TbSteeringWheel } from 'react-icons/tb';
import { buttonTheme } from '../components/themes.js';
import RideCard from '../components/RideCard.jsx';
import { BsPerson } from 'react-icons/bs';
import { getRidesDriverByUserId, getRidesPassengerByUserId } from '../firebase/FirebaseManagement.js';
import Footer from '../components/Footer';

export default function MyRides() {
  const navigate = useNavigate();
  const [driverView, setDriverView] = useState(true);
  const [passangerView, setPassangerView] = useState(false);

  const [driverCards, setDriverCards] = useState(null);
  const [passangerCards, setPassangerCards] = useState(null);

  const handleDriverView = () => {
    setDriverView(!driverView);
    setPassangerView(!passangerView);
  }
  
  // Get the user user id from local storage
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const fetchRides = async () => {
      const rides = await getRidesDriverByUserId(userId);
      if (rides.length > 0) {
        setDriverCards(rides);
      }
    };
    fetchRides();
  }, []);

  useEffect(() => {
    const fetchRides = async () => {
      const rides = await getRidesPassengerByUserId(userId);
      if (rides.length > 0) {
        setPassangerCards(rides);
      }
    };
    fetchRides();
  }, []);

  return (
    <div className='flex flex-col items-center md:w[500px]'> 
      <h1 className="text-3xl">My Rex<span className='span-titles'>Rides</span></h1>
      <div className='mt-[30px]'>
        <Flowbite theme={{ theme: buttonTheme }}>
          <Button.Group>
            <Button color={driverView ? "primary" : "secondary"} onClick={handleDriverView}>
              <TbSteeringWheel />
              <p>Driver</p>
            </Button>

            <Button color={passangerView ? "primary" : "secondary"} onClick={handleDriverView}>
              <BsPerson />
              <p>Passenger</p>
            </Button>
          </Button.Group>
        </Flowbite>
      </div>
      <div className='mt-[40px] w-full flex flex-wrap gap-10 justify-center'>
        {driverView ? driverCards ?
          driverCards?.map((ride) => {
            return (
              <div  onClick={() => navigate(`/rexridedetails/${ride.id}`)}>
                <RideCard rideDetails={ride} />
              </div>
            )
          }) :
          <div>
            <Alert
              color="warning"
              rounded
            >
              <span>
                <p>
                  You don't have any rides as a driver yet.
                </p>
              </span>
            </Alert>
          </div> : ""
        }

        {passangerView ? passangerCards ?
          passangerCards?.map((ride) => {
            return (
              <div onClick={() => navigate(`/rexridedetails/${ride.id}`)}>
                <RideCard rideDetails={ride} />
              </div>
            )
          }) :

          <div>
            <Alert
              color="warning"
              rounded
            >
              <span>
                <p>
                  You don't have any rides as a passenger yet.
                </p>
              </span>
            </Alert>
          </div> : ""
        }
      </div>
      <Flowbite theme={{theme:buttonTheme}}>
        <Button color="primary" className="max-w-[400px] mt-5" onClick={()=>navigate("/create-ride")}>Create RexRide</Button>
      </Flowbite>
      
      <Footer/>
    </div>
  );
}
